import { ComponentStyleConfig } from "@chakra-ui/react";
import type { SystemStyleObject } from "@chakra-ui/theme-tools";

export const baseStyle: SystemStyleObject = {
	fontSize: "body2",
	fontWeight: "body2",
	lineHeight: "body2",
	letterSpacing: "body2",
	color: "gray.800",
};

const componentOverride: ComponentStyleConfig = {
	baseStyle: baseStyle,
};

export default componentOverride;
